import { render } from "./AText.vue?vue&type=template&id=1b8a8c48"
import script from "./AText.vue?vue&type=script&lang=js"
export * from "./AText.vue?vue&type=script&lang=js"

import "./AText.vue?vue&type=style&index=0&id=1b8a8c48&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__